var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSecurity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/icon/security") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.7002 0.5 29.3 0.5 29.3 31.5 0.7002 31.5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/icon/security",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2002,7 L3.2002,16 C3.2002,18.4 10.5002,26.4 15.0002,28.6 C19.5002,26.4 26.8002,18.4 26.8002,16 L26.8002,7 L24.5002,7 C23.0992,7 21.9002,6.1 20.5002,5.2 C18.9002,4.1 17.0992,2.9 15.0002,2.9 C12.9002,2.9 11.1002,4.1 9.5002,5.2 C8.1002,6.1 6.9002,7 5.5002,7 L3.2002,7 Z M15.0002,31.5 L15.0002,31.5 L12.1002,29.8 C7.3002,26.5 0.7002,19.5 0.7002,16 L0.7002,4.5 L5.5002,4.5 C6.1002,4.5 7.1002,3.8 8.1002,3.2 C9.9002,2 12.1002,0.5 15.0002,0.5 C17.9002,0.5 20.0992,2 21.9002,3.2 C22.9002,3.9 23.9002,4.5 24.5002,4.5 L29.3002,4.5 L29.3002,16 C29.3002,19.5 22.7002,26.5 17.9002,29.7 L15.0002,31.5 Z",
    id: "Fill-1",
    fill: "#0078D7",
    mask: "url(#mask-2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon_security.01d57004efe16d84ad6ba171655d4259.svg";
export { ForwardRef as ReactComponent };